export const subscribeToList = async (email, listId) => {
  try {
    const response = await fetch('/api/integrations/zaius/subscribe-to-list', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, listId }),
    });

    return await response.json();
  } catch {
    return { success: false, error: 'Internal server error' };
  }
};

export const trackProductSavedEvent = async (email, payload = {}) => {
  try {
    const response = await fetch('/api/integrations/zaius/track-event', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, ...payload }),
    });

    return await response.json();
  } catch {
    return { success: false, error: 'Internal server error' };
  }
};
